import { firebaseShared } from "@shared/firebase.js";
import * as firebase from "@shared/firebase.js";
import * as environment from "@shared/environment.js";
import * as utility from "@shared/utility.js";
import * as imageCache from "@shared/imageCache.js";
import { featuredCollWithID } from "@shared/featuredCollections.js";
import { dlog } from "@shared/utility.js";
import { cfAccountHash } from "@shared/cloudflare.js";

let allStickerSets = [];
let totalStickerSetCnt = 0;

function stickerSetWithID(id) {
    return allStickerSets.find(item => item.id === id);
}

function allStickerSetsForFeaturedCollID(collID, limit = 999999) {
    if (collID === "everything") {
        return allStickerSets.slice(0, limit);
    } else {
        const coll = featuredCollWithID(collID);

        const filteredItems = coll.itemIDs.map(id => 
            allStickerSets.find(item => item.id === id)
        ).filter(item => item !== undefined).slice(0, limit);

        return filteredItems;
    }
}

function allStickerSetsCountForCollID(collID) {
    if (collID === "everything") {
        return allStickerSets.length;
    } else {
        const coll = featuredCollWithID(collID);
        return coll.itemIDs.length;
    }
}

async function imageArrayForSetWithID(id, quality=85) {
    const stickerSet = stickerSetWithID(id);
    const stickerIDs = stickerSet.stickerIDs;
    
    if (!stickerIDs || stickerIDs.length === 0) {
        throw new Error(`No sticker IDs found for sticker set: ${stickerSet.id}`);
    }
    
    const promises = stickerIDs.map(async stickerID => {
        // Always fetch stickers at their native size.
        const url = `https://imagedelivery.net/${cfAccountHash}/${stickerID}/w=10000,format=webp,quality=${quality},dpr=1`;
        return imageCache.getLoadAndStoreURL(url);
    });
    return Promise.all(promises);
}

async function fetchStickerSets(force=false, includeDebug=false) {
    // Due to some weird firebase bug(?) where the auth token times out (I think in 30m), let's avoid trying to re-fetch feeds from firebase if we already have them.
    if (!force && allStickerSets.length > 0) {
        dlog("already fetched sticker sets. bailing.");
        return;
    }

    try {
        dlog(`fetchStickerSets: start; collection: ${environment.currentStickerSetCollectionName()}`);

        const collectionRef = firebase.collection(firebaseShared.db, environment.currentStickerSetCollectionName());
        dlog(`fetchStickerSets: got collectionRef`);
        
        const snapshot = await firebaseShared.withRetry(() => firebase.getDocs(collectionRef));
        dlog(`fetchStickerSets: got snapshot`);

        const tempStickerSets = [];

        snapshot.forEach(doc => {
            const item = doc.data();
            if (item.isLive === true && (includeDebug || !item.id.includes("debug") ) ) {
                tempStickerSets.push(item);
            } else {
                dlog(`ignoring disabled (isLive=false) item: ${item.id}`);
            }
        });
        
        if (tempStickerSets.length === 0) {
            let blankItem = createNewStickerSet();
            tempStickerSets.push(blankItem);
        }

        utility.sortByModDate(tempStickerSets);
        
        allStickerSets = tempStickerSets;
        totalStickerSetCnt = allStickerSets.length;
        
        dlog("allStickerSets count: " + allStickerSets.length);
    } catch (error) {
        console.warn("fetchStickerSets failed after retries:", error);
        return;
    }
    
    dlog(`fetchStickerSets: ${allStickerSets.length} items in collection`);
}

function createNewStickerSet() {
    let newStickerSet = {};
    newStickerSet.id = `sticker-set-${randomString(12)}`;
    newStickerSet.isLive = true;
    return newStickerSet;
}

export { allStickerSets, totalStickerSetCnt, stickerSetWithID, allStickerSetsForFeaturedCollID, allStickerSetsCountForCollID, fetchStickerSets, imageArrayForSetWithID };